import { PaintedScene } from '../PaintedScene';

export const COOLING_FLOW_PHASER_KEY = 'CoolingFlowScene' as const;
export const COOLING_FLOW_MANIFEST_KEY = 's-404-cooling-flow' as const;

export class CoolingFlowScene extends PaintedScene {
  constructor() {
    super(COOLING_FLOW_PHASER_KEY, COOLING_FLOW_MANIFEST_KEY);
  }
}
